// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"067884e0358634795ca9","655":"78131565862a1f6e0108"}[chunkId] + ".js";
};